module.exports = __webpack_public_path__ + "img/swift-bostergreen-gls-rojo-vanadio.41053f06.png";